import { About } from "../components/sections/About";
import { StandaloneSection } from "./StandaloneSection";

export default function AboutPage() {
    return (
        <StandaloneSection>
            <About />
        </StandaloneSection>
    );
}
